import { Extension } from '@tiptap/core';
import '@tiptap/extension-text-style';
import { ShadowSettingKey } from '../../models/setting/shadow-setting';

export type ShadowOptions = {
  types: string[];
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    shadow: {
      /**
       * Set the text shadow
       */
      setShadow: (shadow: ShadowSettingKey) => ReturnType;
      /**
       * Unset the text shadow
       */
      unsetShadow: () => ReturnType;
    };
  }
}

export const Shadow = Extension.create<ShadowOptions>({
  name: 'shadow',

  addOptions() {
    return {
      types: ['textStyle'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          shadow: {
            default: null,
            parseHTML: (element) => element.style.textShadow?.replace(/['"]+/g, ''),
            renderHTML: (attributes) => {
              if (!attributes.shadow || attributes.shadow === 'NONE') {
                return {};
              }

              return {
                class: getShadowClass(attributes.shadow),
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setShadow:
        (shadow) =>
        ({ chain }) => {
          return chain().setMark('textStyle', { shadow }).run();
        },
      unsetShadow:
        () =>
        ({ chain }) => {
          return chain().setMark('textStyle', { shadow: null }).removeEmptyTextStyle().run();
        },
    };
  },
});

function getShadowClass(shadowValue: ShadowSettingKey) {
  switch (shadowValue) {
    case 'HARD':
      return 'shadow-hard';
    case 'MEDIUM':
      return 'shadow-medium';
    case 'SOFT':
      return 'shadow-soft';
    default:
      return '';
  }
}
